import { AppConsts } from '@shared/AppConsts';
import { Component, Injector, ViewEncapsulation, ViewChild, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import {
    SalesInvoiceServiceProxy,
    SalesDto,
    Status,
    PaymentStatus,
    TaxType,
    PurchaseType,
    EntityDto,
    DropDownLookupDto,
    CommonLookupServiceProxy,
} from '@shared/service-proxies/service-proxies';

import { NotifyService } from 'abp-ng2-module';
import { AppComponentBase } from '@shared/common/app-component-base';
import { TokenAuthServiceProxy } from '@shared/service-proxies/service-proxies';

import { appModuleAnimation } from '@shared/animations/routerTransition';
import { Table, TableModule } from 'primeng/table';
import { Paginator, PaginatorModule } from 'primeng/paginator';
import { LazyLoadEvent, PrimeTemplate } from 'primeng/api';
import { FileDownloadService } from '@shared/utils/file-download.service';
import { filter as _filter } from 'lodash-es';
import { DateTime } from 'luxon';

import { DateTimeService } from '@app/shared/common/timing/date-time.service';

import { HttpClient } from '@angular/common/http';
import { FileUpload, FileUploadModule } from 'primeng/fileupload';
import { finalize } from 'rxjs';
import { UtilsService } from 'app/shared/common/utils/utils-service';

import { ExcelColumnSelectionModalComponent } from '@app/shared/common/excel-column-selection/excel-column-selection-modal';
import { environment } from 'environments/environment';
import * as moment from 'moment';


@Component({
    templateUrl: './salesInvoices.component.html',
    encapsulation: ViewEncapsulation.None,
    animations: [appModuleAnimation()],
    standalone: false,
})
export class SalesInvoicesComponent extends AppComponentBase {
    @ViewChild('dataTable', { static: true }) dataTable: Table;
    @ViewChild('paginator', { static: true }) paginator: Paginator;

    @ViewChild('ExcelFileUpload', { static: false }) excelFileUpload: FileUpload;

    @ViewChild('excelColumnSelectionModal', { static: true })
    excelColumnSelectionModal: ExcelColumnSelectionModalComponent;

    advancedFiltersAreShown = false;
    filterText = '';

    maxPTaxFilter: number;
    maxPTaxFilterEmpty: number;
    minPTaxFilter: number;
    minPTaxFilterEmpty: number;
    vendorDisplayPropertyFilter = '';
    paymentTermNameFilter = '';

    status = Status;
    paymentStatus = PaymentStatus;
    taxType = TaxType;
    purchaseType = PurchaseType;

    uploadUrl: string;
    allCustomers: DropDownLookupDto[];
    allPaymentTerms: DropDownLookupDto[];
    allStatus: DropDownLookupDto[];
    customerId: 0;
    paymentTermId: 0;
    dateRangeSelected = false;
    sNo: '';
    referenceNo: '';
    invoiceStatus = 0;
    dateRange: Date[] = [];

    constructor(
        injector: Injector,
        private _salesInvoicesServiceProxy: SalesInvoiceServiceProxy,
        private _notifyService: NotifyService,
        private _tokenAuth: TokenAuthServiceProxy,
        private _activatedRoute: ActivatedRoute,
        private _fileDownloadService: FileDownloadService,
        private _router: Router,
        private _dateTimeService: DateTimeService,
        private _httpClient: HttpClient,
        public utilsService: UtilsService,
        private _commonLookupServiceProxy: CommonLookupServiceProxy,
    ) {
        super(injector);

        this.uploadUrl = AppConsts.remoteServiceBaseUrl + '/SalesInvoices/ImportFromExcel';
    }

    ngOnInit(): void {
        this.initializeDateRange();
        this.populateDropDowns();
    }



    initializeDateRange() {
        const today = new Date();
        this.dateRange = [
            new Date(today.getFullYear(), today.getMonth(), today.getDate()),
            new Date(today.getFullYear(), today.getMonth(), today.getDate())
        ];
    }

    OnselectDateRange(event: Event) {
        const isChecked = (event.target as HTMLInputElement).checked;
        this.dateRangeSelected = isChecked;

    }

    setDateRange(type: string) {
        const today = new Date();
        let start: Date, end: Date;

        switch (type) {
            case 'today':
                start = end = today;
                break;
            case '7days':
                start = new Date();
                start.setDate(today.getDate() - 6);
                end = today;
                break;
            case '30days':
                start = new Date();
                start.setDate(today.getDate() - 29);
                end = today;
                break;
            case 'thisMonth':
                start = new Date(today.getFullYear(), today.getMonth(), 1);
                end = new Date(today.getFullYear(), today.getMonth() + 1, 0);
                break;
            case 'lastMonth':
                start = new Date(today.getFullYear(), today.getMonth() - 1, 1);
                end = new Date(today.getFullYear(), today.getMonth(), 0);
                break;
            default:
                start = end = today;
        }

        this.dateRange = [start, end];
    }

    populateDropDowns() {
        this._commonLookupServiceProxy.getAllCustomerForTableDropdown().subscribe((result) => {
            this.allCustomers = result;
            this.customerId = 0;
        });

        this._commonLookupServiceProxy.getAllPaymentTermForTableDropdown().subscribe((result) => {
            this.allPaymentTerms = result;
            this.paymentTermId = 0;
        });

        this._commonLookupServiceProxy.getAllPurchaseInvoiceStatusForTableDropdown().subscribe((result) => {
            this.allStatus = result;
            this.invoiceStatus = 0;
        });
    }

    getsalesInvoices(event?: LazyLoadEvent) {
        if (this.primengTableHelper.shouldResetPaging(event)) {
            this.paginator.changePage(0);
            if (this.primengTableHelper.records && this.primengTableHelper.records.length > 0) {
                return;
            }
        }

        this.primengTableHelper.showLoadingIndicator();
        const startDate = moment(this.dateRange[0]).format('YYYY-MM-DD');
        const endDate = moment(this.dateRange[1]).format('YYYY-MM-DD');
        this._salesInvoicesServiceProxy
            .getAll(
                this.invoiceStatus,
                this.customerId,
                this.paymentTermId,
                this.sNo,
                this.referenceNo,
                this.dateRangeSelected,
                startDate ? DateTime.fromISO(startDate) : undefined,
                endDate ? DateTime.fromISO(endDate) : undefined,
                this.appSession.user.locationId,
                this.primengTableHelper.getSorting(this.dataTable),
                this.primengTableHelper.getSkipCount(this.paginator, event),
                this.primengTableHelper.getMaxResultCount(this.paginator, event),
            )
            .subscribe((result) => {
                this.primengTableHelper.totalRecordsCount = result.totalCount;
                this.primengTableHelper.records = result.items;
                this.primengTableHelper.hideLoadingIndicator();
            });
    }

    reloadPage(): void {
        this.paginator.changePage(this.paginator.getPage());
    }

    createSalesInvoice(): void {
        this._router.navigate(['/app/sales/salesInvoices/createOrEdit']);
    }

    print(id:number): void{
        window.open(AppConsts.remoteServiceBaseUrl + '/Sales/SalesInvoice/' + id, '_blank');
    }

    printVoucher(id: number): void {
        window.open(AppConsts.remoteServiceBaseUrl + '/Account/JournalVoucher/' + id, '_blank');
    }

    deleteSalesInvoice(purchaseOrder: SalesDto): void {
        this.message.confirm('', this.l('AreYouSure'), (isConfirmed) => {
            if (isConfirmed) {
                this._salesInvoicesServiceProxy.delete(purchaseOrder.id).subscribe(() => {
                    this.reloadPage();
                    this.notify.success(this.l('SuccessfullyDeleted'));
                });
            }
        });
    }
    convertToDraft(salesInvoice: SalesDto): void {
        this.primengTableHelper.showLoadingIndicator();
        var entitDto = new EntityDto();
        entitDto.id = salesInvoice.id;
        this._salesInvoicesServiceProxy.convertSalesInvoiceToDraft(entitDto).subscribe(() => {
            this.getsalesInvoices({});
            this.notify.success(this.l('SuccessfullyDraft'));
            this.primengTableHelper.hideLoadingIndicator();
        });
    }
    convertToInvoiced(salesInvoice: SalesDto): void {
        var entitDto = new EntityDto();
        this.primengTableHelper.showLoadingIndicator();
        entitDto.id = salesInvoice.id;
        this._salesInvoicesServiceProxy.convertDraftToSalesInvoice(entitDto).subscribe(() => {
            this.getsalesInvoices({});
            this.notify.success(this.l('SuccessfullyApproved'));
            this.primengTableHelper.hideLoadingIndicator();
        });
    }

    exportToExcel($event): void {
        //this._salesInvoicesServiceProxy
        //    .getSalesInvoicesToExcel(
        //        this.filterText,
        //        $event,
        //        this.maxPTaxFilter == null ? this.maxPTaxFilterEmpty : this.maxPTaxFilter,
        //        this.minPTaxFilter == null ? this.minPTaxFilterEmpty : this.minPTaxFilter,
        //        this.vendorDisplayPropertyFilter,
        //        undefined,
        //        this.paymentTermNameFilter,
        //        undefined,
        //    )
        //    .subscribe((result) => {
        //        this._fileDownloadService.downloadTempFile(result);
        //    });
    }

    uploadExcel(data: { files: File }): void {
        const formData: FormData = new FormData();
        const file = data.files[0];
        formData.append('file', file, file.name);

        this._httpClient
            .post<any>(this.uploadUrl, formData)
            .pipe(finalize(() => this.excelFileUpload.clear()))
            .subscribe((response) => {
                if (response.success) {
                    this.notify.success(this.l('ImportSalesInvoiceProcessStart'));
                } else if (response.error != null) {
                    this.notify.error(this.l('ImportSalesInvoicesUploadFailed'));
                }
            });
    }

    onUploadExcelError(): void {
        this.notify.error(this.l('ImportSalesInvoicesUploadFailed'));
    }

    resetFilters(): void {
        this.filterText = '';
        this.maxPTaxFilter = this.maxPTaxFilterEmpty;
        this.minPTaxFilter = this.maxPTaxFilterEmpty;
        this.vendorDisplayPropertyFilter = '';
        this.paymentTermNameFilter = '';

        this.getsalesInvoices();
    }

    showExcelColumnSelectionModal() {
        this._salesInvoicesServiceProxy.getSalesInvoiceExcelColumnsToExcel().subscribe((result) => {
            this.excelColumnSelectionModal.show(result);
        });
    }

}
